import React from 'react';
import type { IconProps } from './IconProps';

/** Building / bank transfer (POS payment tab). */
const BankBuildingIcon: React.FC<IconProps> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M3 21h18" />
    <path d="M5 21V7l7-4 7 4v14" />
    <path d="M9 21v-4h6v4" />
    <path d="M9 11h6" />
    <path d="M9 15h6" />
  </svg>
);

export default BankBuildingIcon;
